import { ReactElement } from 'react'
import { StyledButton } from './Button.style'
import { ButtonVariant } from './ButtonVariant'

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  variant?: ButtonVariant
  fullWidth?: boolean
  icon?: ReactElement<any, any>
  noBorder?: boolean
}

export const LogoButton = ({
  variant,
  fullWidth,
  icon,
  noBorder,
  ...rest
}: ButtonProps) => {
  return (
    <StyledButton
      $variant={variant}
      $fullWidth={fullWidth}
      disabled={variant === ButtonVariant.Disabled}
      $isLogo={true}
      $noBorder={noBorder}
      $noBackground={noBorder}
      {...rest}
    >
      {icon}
    </StyledButton>
  )
}
